// extracted by mini-css-extract-plugin
export var smallSpinner = "_rp-0";